module.exports = __webpack_public_path__ + "static/img/our-people-company-program-hero-lowres.c37ae4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-company-program-hero-lowres.jpg
// module id = 6izg
// module chunks = 0